<app-base-modal
  [title]="getTitle()"
>
  @if(isLoading) {
    <app-loader/>
  }
  @if (dialogData.key) {
    <div class="files">
      @for (item of singleFilesParamsService.singleFilesParams(); track $index) {
        <app-file-card
          [fileCard]="{
            id: item.id,
            fileParams: item.file,
            fileType: dialogData.key,
            isEditModeActive: getEditMode(),
            shouldCheckImageType: false
          }"
          (handleDelete)="handleDelete($event, item)"
        />
      } @empty {
        <div class="files-empty">
          Нет загруженных файлов.
        </div>
      }
    </div>
    @if (loginAndRoles?.role !== 'ROLE_PROMOTION_SPECIALIST' && !dialogData.noUploadComponent) {
      <div class="files-new">
        <app-file-upload-card
          [fileUploadParams]="{
            recordId: dialogData.recordId,
            parentId: dialogData.recordCalendarId,
            type: dialogData.key,
            entityFileType: 'RECORD_CALENDAR'
          }"
          [isEditModeActive]="isEditModeActive"
          (attachFile)="attachFile($event)"
        />
      </div>
    }
  }
</app-base-modal>
